import { GridCol } from '@/components/ui/layouts/grids/GridCol';
import { GridRow } from '@/components/ui/layouts/grids/GridRow';
import { gridCol, gridRow, textStyles } from '@mage-ui/styled-system/recipes';

export const CarouselGridText = ({ children, data, ...props }) => {
  return (
    <GridRow
      className={gridRow({
        gap: 'gap400',
        colGapM: 'gap500',
        colGapL: 'gap600',
      })}
      {...props}
    >
      <GridCol className={gridCol({ colSpanM: '4', colSpanL: '4' })}>
        {children}
      </GridCol>
      <GridCol className={gridCol({ colSpanM: '8', colSpanL: '8' })}>
        <div
          className={textStyles()}
          dangerouslySetInnerHTML={{ __html: data?.description || '' }}
        />
      </GridCol>
    </GridRow>
  );
};
